// extracted by mini-css-extract-plugin
export default {"table":"Outlier_table__XHhyg","outlier":"Outlier_outlier__7gqvO","warningText":"Outlier_warningText__mkfyC","validText":"Outlier_validText__ThmkE","noData":"Outlier_noData__ZNpBd"};